// controllers/review.controller.js
import { reviewService } from '../services/ReviewAnime'
import { socketService } from '../services/socket.service'

export const reviewController = {
  fetchReviews,
  fetchReviewById,
  addReview,
  editReview,
  removeReview,
}

async function fetchReviews(filter) {
  try {
    return await reviewService.query(filter)
  } catch (err) {
    console.error('Error in fetchReviews:', err)
    throw err
  }
}

async function fetchReviewById(reviewId) {
  try {
    const review = await reviewService.getById(reviewId)
    if (!review) throw new Error(`Review with ID ${reviewId} not found`)
    return review
  } catch (err) {
    console.error('Error in fetchReviewById:', err)
    throw err
  }
}

async function addReview(reviewData, loggedInUser) {
  try {
    if (!loggedInUser) throw new Error('User must be logged in to add a review')
    reviewData.userId = loggedInUser._id
    const newReview = await reviewService.save(reviewData)
    socketService.emit('review-added', newReview)
    return newReview
  } catch (err) {
    console.error('Error in addReview:', err)
    throw err
  }
}

async function editReview(reviewId, updatedData, loggedInUser) {
  try {
    const review = await reviewService.getById(reviewId)
    if (!review) throw new Error(`Review with ID ${reviewId} not found`)
    if (
      review.userId.toString() !== loggedInUser._id.toString() &&
      loggedInUser.role !== 'admin'
    ) {
      throw new Error('Unauthorized action: Cannot edit review')
    }
    const updatedReview = { ...review, ...updatedData }
    const savedReview = await reviewService.save(updatedReview)
    socketService.emit('review-updated', savedReview)
    return savedReview
  } catch (err) {
    console.error('Error in editReview:', err)
    throw err
  }
}

async function removeReview(reviewId, loggedInUser) {
  try {
    const review = await reviewService.getById(reviewId)
    if (!review) throw new Error(`Review with ID ${reviewId} not found`)
    if (
      review.userId.toString() !== loggedInUser._id.toString() &&
      loggedInUser.role !== 'admin'
    ) {
      throw new Error('Unauthorized action: Cannot remove review')
    }
    await reviewService.remove(reviewId)
    socketService.emit('review-removed', reviewId)
    return reviewId
  } catch (err) {
    console.error('Error in removeReview:', err)
    throw err
  }
}
